import { render, staticRenderFns } from "./add-categories.vue?vue&type=template&id=dd1cc60e&scoped=true"
import script from "./add-categories.vue?vue&type=script&lang=js"
export * from "./add-categories.vue?vue&type=script&lang=js"
import style0 from "./add-categories.vue?vue&type=style&index=0&id=dd1cc60e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1cc60e",
  null
  
)

export default component.exports